export const STATE_IDENTIFIER = {
  ALL_AUDITS: "allAudits",
  RESPONSE_STATE: "responseState",
  LOADER_IDENTIFIER: "loader",
};

export interface IAuditList {
  id: "string";
  auditDate: "string";
  description: "string";
  objectDesc: "string";
  objectId: "string";
  objectIdentitySystemId: "string";
  objectType: "string";
  operation: "string";
  operationBy: "string";
  subjectDesc: "string";
  subjectId: "string";
  subjectIdentitySystemId: "string";
  subjectType: "string";
}

export interface IAuditListResponse {
  pageNumber: number;
  totalElements: number;
  pageTotalNumber: number;
  pageSize: number;
  responseStatus: string;
  audit: IAuditList[];
}

export interface IAuditListBody extends IAuditList {
  pageNumber: number;
  pageSize: number;
}

export enum IMillisecondsExternalPortalConditions {
  RELATIONSHIP_END_DATE_CONSULTANT_DIFFERENCE = "34187400000",
  RELATIONSHIP_END_DATE_OUTSOURCER = "4102354800000",
  RELATIONSHIP_END_DATE_DIFFERENCE = "34187400000",
  SINGLE_DAY_MILLISECONDS = "86400000",
  ONE_MINUTE_TO_MIDNIGHT_CONVERTER = "86399000",
}
